import { render } from 'preact';
import App from './App';
import styles from './styles.css?inline';

function mount() {
  try {
    if (document.getElementById('stratus-chat-root')) return;
    const host = document.createElement('div');
    host.id = 'stratus-chat-root';
    document.body.appendChild(host);
    const shadow = host.attachShadow({ mode: 'open' });

    const styleEl = document.createElement('style');
    styleEl.textContent = styles;
    shadow.appendChild(styleEl);

    const mountPoint = document.createElement('div');
    shadow.appendChild(mountPoint);

    const apiBase =
      (window as unknown as { STRATUS_CHAT_API_URL?: string }).STRATUS_CHAT_API_URL ??
      'https://chat.stratus.finance';
    render(<App apiBase={apiBase} />, mountPoint);
  } catch (err) {
    console.error('stratus-chat: shadow DOM mount failed', err);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}
